import {modalController} from '@ionic/vue';
import LocationSearchModal from "@/components/Modals/LocationSearchModal";

class LocationSearchModalHelper {
    open() {
        return modalController.create({
            component: LocationSearchModal,
            componentProps: {
                title: 'Location Search'
            }
        }).then(modal => {
            modal.present();
            return modal.onDidDismiss();
        });
    }
}
export default new LocationSearchModalHelper();
